// FTL ids for the checklist of things we extract from the invoice. Kept in the
// same order as the backend's scanning checkpoints, so each row maps to the
// status progression reported by the invoice poll.
export const LOOKING_FOR_ITEMS = [
  "invoice-upload-item-recipient",
  "invoice-upload-item-amount",
  "invoice-upload-item-recommended",
];

// how much to magnify the image when zooming to a highlight
export const HIGHLIGHT_ZOOM = 5;

// breathing room around the extracted region, as a fraction of the box's own
// height (i.e. of the text). applied evenly on all four sides -- the horizontal
// side is divided by the page ratio so the gap looks square rather than
// stretched, since x and y are normalized against different page dimensions.
export const HIGHLIGHT_PAD = 0.15;

// border/radius are drawn inside the scaled wrapper, so they'd be multiplied by
// HIGHLIGHT_ZOOM. these are the intended on-screen pixel values, divided back
// down at render time.
export const HIGHLIGHT_BORDER_PX = 3;
export const HIGHLIGHT_RADIUS_PX = 8;

// a band of the fill colour bleeding out past the border, so the highlight
// fades into the page instead of stopping hard at the outline
export const HIGHLIGHT_GLOW_PX = 5;
